var _path, _g, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolderYellow = function SvgFolderYellow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.08,
    d: "M4.25 10.861c0-3.083 1.02-4.111 4.083-4.111h4.084c2.041 0 4.083 2.056 6.125 2.056h6.125c3.062 0 4.083 1.027 4.083 4.11v8.223c0 3.083-1.02 4.111-4.083 4.111H8.333c-3.062 0-4.083-1.028-4.083-4.111z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg_icon_folder_yellow__filter0_dd_2424_32830)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDD63",
    d: "M4.5 11c0-3 1-4 4-4h4c2 0 4 2 6 2h6c3 0 4 1 4 4v8c0 3-1 4-4 4h-16c-3 0-4-1-4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_folder_yellow__paint0_linear_2424_32830)",
    fillOpacity: 0.04,
    d: "M4.5 11c0-3 1-4 4-4h4c2 0 4 2 6 2h6c3 0 4 1 4 4v8c0 3-1 4-4 4h-16c-3 0-4-1-4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_folder_yellow__paint1_linear_2424_32830)",
    fillOpacity: 0.24,
    d: "M4.5 11c0-3 1-4 4-4h4c2 0 4 2 6 2h6c3 0 4 1 4 4v8c0 3-1 4-4 4h-16c-3 0-4-1-4-4z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE26E",
    d: "M4.5 14c0-2 .75-3 2.75-3H25.5q3 0 3 3v7c0 3-1 4-4 4h-16c-3 0-4-1-4-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_folder_yellow__paint2_linear_2424_32830)",
    fillOpacity: 0.16,
    d: "M4.5 14c0-2 .75-3 2.75-3H25.5q3 0 3 3v7c0 3-1 4-4 4h-16c-3 0-4-1-4-4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_folder_yellow__paint3_linear_2424_32830)",
    fillOpacity: 0.08,
    d: "M4.5 14c0-2 .75-3 2.75-3H25.5q3 0 3 3v7c0 3-1 4-4 4h-16c-3 0-4-1-4-4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_folder_yellow__paint4_linear_2424_32830)",
    fillOpacity: 0.08,
    d: "M4.5 14c0-2 .75-3 2.75-3H25.5q3 0 3 3v7c0 3-1 4-4 4h-16c-3 0-4-1-4-4z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_folder_yellow__paint0_linear_2424_32830",
    x1: 16.5,
    x2: 16.5,
    y1: 12.5,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_folder_yellow__paint1_linear_2424_32830",
    x1: 16.5,
    x2: 16.5,
    y1: 13.75,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_folder_yellow__paint2_linear_2424_32830",
    x1: 16.5,
    x2: 16.5,
    y1: 11,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_folder_yellow__paint3_linear_2424_32830",
    x1: 16.5,
    x2: 16.5,
    y1: 11,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_folder_yellow__paint4_linear_2424_32830",
    x1: 16.5,
    x2: 16.5,
    y1: 11,
    y2: 14.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "svg_icon_folder_yellow__filter0_dd_2424_32830",
    width: 28,
    height: 22,
    x: 2.5,
    y: 7,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2424_32830"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2424_32830",
    result: "effect2_dropShadow_2424_32830"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2424_32830",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolderYellow);
export { ForwardRef as ReactComponent };